import React, {useState} from "react";
import styled from "@emotion/styled/macro";
import {
    Grid2 as Grid,
    Typography,
    Divider,
    Button,
    Tooltip
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import SilhouettePortrait from './assets/recommendation_images/person_silhouette_icon.webp';


import {TESTIMONIALS} from './content';


const StyledGridContainer = styled(Grid)`
    height: 100%;
    align-items: center;
    font-family: poppins;
    min-width: 200px;
    margin: 5vh auto;
    margin-top: 5vh;
    min-height: 400px;
`;
const StyledTestimonialBodyGridItem = styled(Grid)`
    text-align: center;
`;
const StyledTestimonialControlsGridItem = styled(Grid)`
    text-align: center;
`;
const StyledArrowBackButton = styled(Button)`
    color: black;
    &:hover {
        left: -1px;
    }
    &:active {
        left: 0px;
    }
`;
const StyledArrowForwardButton = styled(Button)`
    color: black;
    &:hover {
        left: 1px;
    }
    &:active {
        left: 0px;
    }
`;

const StyledTestimonialPortrait = styled.img`
    margin-top: 1vh;
    margin-bottom: 1vh;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    transition: all 0.25s;

    &:hover {
        scale: 1.10;
        cursor: pointer;
    }
`;
const StyledTestimonialBody = styled(Typography)`
    font-family: poppins;
    text-align: center;
    margin: 0 15%;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-weight: 400;
    pointer-events: none;
`;
const responsiveTestimonialBody = {
    minHeight: {
        xs: "420px",
        msm: "300px",
        sm: "200px",
        md: "190px",
        lg: "120px"
    },
    maxHeight: {
        xs: "420px",
        msm: "300px",
        sm: "200px",
        md: "190px",
        lg: "120px"
    },
    margin: {
        xs: "0",
        md: "0 15%"
    }
};
const StyledTestimonialAuthor = styled(Typography)`
    font-family: poppins;
    text-align: center;
    display: block;
    color: gray;
    margin-left: 33%;
    margin-right: 33%;
    transition: all 0.25s;

    &:hover {
        scale: 1.10;
        cursor: pointer;
    }
`;
const responsiveTestimonialAuthor = {
    minHeight: {
        xs: "100px",
        sm: "100px",
        md: "100px",
        lg: "50px"
    },
    maxHeight: {
        xs: "100px",
        sm: "100px",
        md: "100px",
        lg: "50px"
    },
    margin: {
        xs: "0", 
        md: "0 33%"
    }
}
const StyledTestimonialLink = styled.a`
    text-decoration: none;
`;
const StyledDivider = styled(Divider)`
    margin: 2vh 33%;
    margin-top: 5vh;
`;

const Testimonials = ({imagesPreloaded}) => {
    const [selectedTestimonial, setSelectedTestimonial] = useState(Math.floor(Math.random() * TESTIMONIALS.length));
    const [quoteIndex, setQuoteIndex] = useState(0);
    const getRandomQuote = (recommendation) => {
        return Math.floor(Math.random() * recommendation.QUOTES.length);
    }

    const selectNextTestimonial = () => {
        let maxIndex = TESTIMONIALS.length - 1;
        let nextIndex = selectedTestimonial + 1;
        let newIndex = nextIndex <= maxIndex ? nextIndex : 0;

        setSelectedTestimonial(newIndex);
        setQuoteIndex(getRandomQuote(TESTIMONIALS[newIndex]));
    }

    const selectPreviousTestimonial = () => {
        let maxIndex = TESTIMONIALS.length - 1;
        let prevIndex = selectedTestimonial - 1;
        let newIndex = prevIndex >= 0 ? prevIndex : maxIndex;
        
        setSelectedTestimonial(newIndex);
        setQuoteIndex(getRandomQuote(TESTIMONIALS[newIndex]));
    }


    return ( 
        <React.Fragment>
                <StyledGridContainer container>
                    <StyledTestimonialControlsGridItem size={{xs: 3, md: 3}}>
                        <StyledArrowBackButton onClick={selectPreviousTestimonial} disabled={!imagesPreloaded}>
                            <ArrowBackIcon />
                        </StyledArrowBackButton>
                    </StyledTestimonialControlsGridItem>
                    <StyledTestimonialBodyGridItem size={{xs: 6, md: 6}}>
                        <StyledTestimonialBody sx={responsiveTestimonialBody}>
                            {TESTIMONIALS[selectedTestimonial].QUOTES[quoteIndex || 0]}
                        </StyledTestimonialBody>
                        <StyledDivider variant="middle"/>
                        <StyledTestimonialLink href={TESTIMONIALS[selectedTestimonial].LINK}>
                            <Tooltip title={`Go to ${TESTIMONIALS[selectedTestimonial].AUTHOR}'s LinkedIn`} placement="right" followCursor>
                                    <StyledTestimonialPortrait src={TESTIMONIALS[selectedTestimonial].IMAGE || SilhouettePortrait} alt={`portrait of ${TESTIMONIALS[selectedTestimonial].AUTHOR}`}/>
                                    <StyledTestimonialAuthor sx={responsiveTestimonialAuthor}>
                                        {`${TESTIMONIALS[selectedTestimonial].AUTHOR}, ${TESTIMONIALS[selectedTestimonial].TITLE}`}
                                    </StyledTestimonialAuthor>
                            </Tooltip>
                        </StyledTestimonialLink>
                    </StyledTestimonialBodyGridItem>
                    <StyledTestimonialControlsGridItem size={{xs:3, md: 3}}>
                        <StyledArrowForwardButton onClick={selectNextTestimonial} disabled={!imagesPreloaded}>
                            <ArrowForwardIcon />
                        </StyledArrowForwardButton>
                    </StyledTestimonialControlsGridItem>
                </StyledGridContainer> 
        </React.Fragment>
    );
}
 


export default Testimonials;